// frontend/src/pages/teacher/CourseDetailPage.js

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
import { FaArrowLeft, FaBookOpen, FaChalkboardTeacher, FaUsers, FaPlus, FaSave, FaSpinner, FaListAlt } from 'react-icons/fa';
import '../../assets/styles/global.css';

const CourseDetailPage = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    
    const [course, setCourse] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [uiState, setUiState] = useState({ isUpdating: false, updateError: null, updateSuccess: false });

    // --- Data Fetching ---
    useEffect(() => {
        const fetchData = async () => {
            try {
                // 1. دریافت جزئیات دوره (شامل دروس متصل)
                const courseRes = await axios.get(`${API_BASE_URL}/core/courses/${courseId}/`, getAuthHeaders());
                setCourse(courseRes.data);

                // 💡 نکته: در آینده باید API برای دریافت لیست تمام دروس موجود (Lessons) را اینجا فراخوانی کنیم 
                // تا بتوانیم دروس جدید را به دوره اضافه کنیم.

            } catch (err) {
                console.error("Error fetching course details:", err);
                setError(err.response?.data?.detail || "خطا در بارگذاری جزئیات دوره.");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [courseId]);

    // --- Handlers ---
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCourse(prev => ({ ...prev, [name]: value }));
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setUiState({ isUpdating: true, updateError: null, updateSuccess: false });
        
        const payload = {
            title: course.title,
            grade: course.grade,
            // 💡 در آینده فیلدهای اتصال دروس (Lessons) اینجا ارسال می‌شوند
        };

        try {
            await axios.put(`${API_BASE_URL}/core/courses/${courseId}/`, payload, getAuthHeaders());
            setUiState({ isUpdating: false, updateError: null, updateSuccess: true });
        } catch (err) {
            console.error("Update failed:", err);
            setUiState({ isUpdating: false, updateError: "خطا در ذخیره تغییرات.", updateSuccess: false });
        }
    };

    if (loading) return <div className="text-center p-5"><FaSpinner className="spinner" /> در حال بارگذاری...</div>;
    if (error) return <div className="alert alert-danger mt-16">{error}</div>;

    return (
        <div className="page-container" style={{maxWidth: '900px'}}>
            <Link to="/teacher/courses" className="button button-secondary mb-6 inline-flex items-center"><FaArrowLeft className="ml-2" /> بازگشت به لیست دوره‌ها</Link>
            
            <div className="form-card">
                <div className="form-header">
                    <FaBookOpen className="header-icon" />
                    <div>
                        <h1>ویرایش دوره: {course.title}</h1>
                        <p>مدیریت اطلاعات پایه و اتصال دروس به این دوره.</p>
                    </div>
                </div>

                <form className="form-body" onSubmit={handleUpdate}>
                    {/* Feedback Messages */}
                    {uiState.updateError && <div className="alert alert-danger">{uiState.updateError}</div>}
                    {uiState.updateSuccess && <div className="alert alert-success">تغییرات با موفقیت ذخیره شدند.</div>}

                    {/* عنوان دوره */}
                    <div className="form-group">
                        <label><FaBookOpen /> عنوان دوره</label>
                        <input 
                            type="text"
                            name="title"
                            value={course.title || ''}
                            onChange={handleChange}
                            required
                            disabled={uiState.isUpdating}
                        />
                    </div>

                    {/* پایه و رشته */}
                    <div className="form-group">
                        <label><FaChalkboardTeacher /> پایه و رشته</label>
                        <input 
                            type="text"
                            name="grade"
                            value={course.grade || ''}
                            onChange={handleChange}
                            required
                            disabled={uiState.isUpdating}
                        />
                    </div>

                    {/* --- بخش اتصال دروس (Lesson Linking) --- */}
                    <div className="form-group border-t pt-4 mt-4">
                        <label className="text-xl font-bold"><FaListAlt className="ml-2" /> اتصال دروس</label>
                        <p className="text-gray-500 mb-3">دروس موجود در سیستم را به این دوره متصل کنید. (نیاز به پیاده‌سازی)</p>
                        {/* 💡 اینجا باید لیست دروس موجود نمایش داده شود */}
                    </div>
                    {/* --- End Lesson Linking --- */}


                    <div className="form-actions justify-end">
                        <button type="submit" className="button button-primary" disabled={uiState.isUpdating}>
                            {uiState.isUpdating ? <FaSpinner className="spinner" /> : <FaSave />}
                            {uiState.isUpdating ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CourseDetailPage;